import {SemanticLegendSettings, YAxisValues} from '../../types';
import {parseBucketsFromSemanticLegendSettings} from './parseBuckets';

export function getMutationVarsFromSettings(settings: SemanticLegendSettings) {
  const {customColors, bucketUpperBounds} =
    parseBucketsFromSemanticLegendSettings(settings);
  return {
    metricName: settings.metric ?? '',
    yValue: settings.yAxisValue ?? YAxisValues.Min,
    bucketUpperBounds: bucketUpperBounds?.map(bucket => bucket ?? 0) ?? [],
    excludedRunColor: settings.excludedRunColor ?? '',
    customColors: customColors,
  };
}
